'use strict';

import $ from 'jquery';
import MasonryPopup from '../masonry-popup/masonry-popup';

export default class MasonryGallery {
	constructor($selector) {
		this.$gallery = $selector;
		this.$showAll = $('.masonry-gallery__show-all', $selector);
		this.$hiddenImages = $('.masonry-gallery__more', $selector);
		this.$popup = $('.masonry-gallery__popup', $selector);

		const popUp = new MasonryPopup($selector);

		this.$showAll.on('click', (e) => {
			e.preventDefault();

			this.$showAll.hide();
			this.$hiddenImages.slideDown(300);
		});

		$('li > a', $selector).map((i, ele) => {
			$(ele).on('click', (e) => {
				e.preventDefault();

				const slickIndex = $(ele).data('slickindex');

				popUp.goToSlide(slickIndex);

				if(!this.$popup.hasClass('active')){
					$('body').addClass('fixed');
					this.$popup.addClass('active');
				}
			})
		});
	}
}
